<template>
  <section v-if="rendered">
    <v-card class="table-container">
      <template>
        <v-data-table
          :headers="headers"
          :items="leadsFormulario"
          :search="search"
          sort-by="name"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title"
                >Formulários</v-toolbar-title
              >
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>

              <v-btn
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                @click="export_excel(leadsFormulario)"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
        </v-data-table>
      </template>
    </v-card>
  </section>
</template>

<script>
  import { json2excel } from "js2excel";
  import { decode } from "html-entities";

  export default {
    name: "leadsFormulario",
    data: () => ({
      search: "",
      dialog: false,
      rendered: false,
      headers: [
        { text: "ID", align: "start", sortable: true, value: "id" },
        { text: "Nome do Form", value: "tipologia" },
        { text: "Email", sortable: true, value: "email" },
        // { text: "NIF", sortable: true, value: "NIF" },
        // { text: "Código Postal", sortable: true, value: "cod_postal" },
        // { text: "Localidade", sortable: true, value: "localidade" },
        { text: "Telefone", sortable: true, value: "telefone" },
        // { text: "Assunto", sortable: true, value: "assunto" },
        // { text: "Mensagem", sortable: true, value: "mensagem" },
        // { text: "Empresa", sortable: true, value: "empresa" },
        { text: "Data", sortable: true, value: "data" },
      ],
      leadsFormulario: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
    }),
    mounted() {
      this.initialize();
    },

    methods: {
      export_excel: async function(data) {
        try {
          json2excel({
            data,
            name: "leadsFormulario-list",
            formateDate: "yyyy-mm-dd",
          });
        } catch (e) {
          alert("export error");
        }
      },
      async initialize() {
        this.leadsFormulario = await this.$store.dispatch(
          "listarLeadsFormularios",
          this
        );

        var final = [];

        var leadsForm = Object.values(this.leadsFormulario);
        console.log("aqui", leadsForm);
        for (let i = 0; i < leadsForm.length; i++) {
          var temp = JSON.parse(leadsForm[i].content);
          var apelido = "";
          var nome = "";
          var cod_postal = "";
          var localidade = "";
          var telefone = "";
          var email = "";
          var assunto = "";
          var mensagem = "";
          var empresa = "";
          var nomeOrganizacao = "";
          var NIPC = "";
          var CAE = "";
          var NIF = "";
          var data = new Date(leadsForm[i].created * 1000);
          var hours = data.getHours();
          var minutes = "0" + data.getMinutes();
          var seconds = "0" + data.getSeconds();
          data =
            data.toLocaleDateString("pt-PT").replaceAll("/", "-") +
            " " +
            hours +
            ":" +
            minutes.substr(-2) +
            ":" +
            seconds.substr(-2);
          for (let k = 0; k < temp.length; k++) {
            if (temp[k].label == "Apelido") {
              apelido = temp[k].value;
            }

            if (temp[k].label == "Nome" || temp[k].label == "Nome e apelido") {
              if (apelido != null && apelido != "") {
                nome = temp[k].value + "-" + apelido;
              } else {
                nome = temp[k].value;
              }
            }
            if (temp[k].label == "Código postal") {
              cod_postal = temp[k].value;
            }
            if (temp[k].label == "Localidade") {
              localidade = temp[k].value;
            }
            if (temp[k].label == "Contacto telefónico") {
              telefone = temp[k].value;
            }
            if (temp[k].label == "Email") {
              email = temp[k].value;
            }
            if (temp[k].label == "Nome da Organização") {
              nomeOrganizacao = temp[k].value;
            }
            if (temp[k].label == "Assunto") {
              assunto = temp[k].value;
            }
            if (temp[k].label == "Mensagem") {
              mensagem = temp[k].value;
            }
            if (temp[k].label == "Empresa") {
              empresa = temp[k].value;
            }
            if (temp[k].label == "NIF") {
              NIF = temp[k].value;
            }
            if (temp[k].label == "NIPC") {
              NIPC = temp[k].value;
            }
            if (temp[k].label == "CAE") {
              CAE = temp[k].value;
            }
          }
          final.push({
            id: decode(leadsForm[i].id),
            tipologia: decode(leadsForm[i].form_name),
            data: decode(data),
            nome: decode(nome),
            apelido: decode(apelido),
            email: decode(email),
            telefone: decode(telefone),
            localidade: decode(localidade),
            cod_postal: decode(cod_postal),
            NIF: decode(NIF),
            mensagem: decode(mensagem),
            assunto: decode(assunto),
            empresa: decode(empresa),
            NIPC: decode(NIPC),
            CAE: decode(CAE),
            nomeOrganizacao: decode(nomeOrganizacao),
          });
        }
        this.leadsFormulario = final;
        this.rendered = true;
      },
    },
  };
</script>
